<template>
    <div>
        <v-dialog v-model="open" persistent max-width="600">
            <v-card>
                <v-toolbar :elevation="0" color="primary" dark>
                    <v-toolbar-title v-if="group_id">Edit group</v-toolbar-title>
                    <v-toolbar-title v-else>Create new group</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="close">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-title class="headline"> </v-card-title>
                <v-card-text>
                    <v-form ref="form" class="text-center">
                        <v-card>
                            <v-card-title>Input data</v-card-title>
                            <v-card-text class="pb-8"> 
                                <div v-if="group_id != ''">
                                    <v-row>
                                        <v-col class="text-left">
                                            <v-row>
                                                <v-col>
                                                    <v-row class="text-left mx-auto mt-1 mb-auto">Group name</v-row>
                                                    <v-text-field label="Name" v-model="groupData.name" outlined flat dense solo hide-details></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col class="text-left">
                                                    <v-row class="text-left mx-auto mt-1 mb-auto">Select devices</v-row>
                                                    <v-autocomplete
                                                        v-model="groupData.meters"
                                                        :items="meters"
                                                        item-text="name"
                                                        item-value="id"
                                                        return-object
                                                        outlined
                                                        dense
                                                        chips
                                                        multiple
                                                        flat
                                                    >
                                                        <template v-slot:selection="data">
                                                            <v-chip
                                                            :input-value="data.item.circuit"
                                                            close
                                                            @click:close="remove(data.item)"
                                                            >
                                                            {{ data.item.name }}
                                                            </v-chip>
                                                        </template>
                                                    </v-autocomplete>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </div>
                                <div v-else>
                                    <v-row>
                                        <v-col class="text-left">
                                            <v-row>
                                                <v-col>
                                                    <v-row class="text-left mx-auto mt-1 mb-auto">Group name</v-row>
                                                    <v-text-field label="Name" v-model="groupName" outlined flat dense solo hide-details></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col class="text-left">
                                                    <v-row class="text-left mx-auto mt-1 mb-auto">Select devices</v-row>
                                                    <v-autocomplete
                                                        v-model="selectedMeters"
                                                        :items="meters"
                                                        item-text="name"
                                                        item-value="id"
                                                        return-object
                                                        outlined
                                                        dense
                                                        chips
                                                        multiple
                                                        flat
                                                    >
                                                        <template v-slot:selection="data">
                                                            <v-chip
                                                            :input-value="data.item.circuit"
                                                            close
                                                            @click:close="remove(data.item)"
                                                            >
                                                            {{ data.item.name }}
                                                            </v-chip>
                                                        </template>
                                                    </v-autocomplete>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-card-text>
                        </v-card>  
                    </v-form>  
                </v-card-text>
                <div v-if="group_id != ''">
                    <v-card-actions class="mr-4 mt-n5">
                        <v-spacer></v-spacer>
                        <v-btn color="accent" :disabled="group_id === '' || group_meters.length === 0" small class="ml-2" @click="save">Save</v-btn>
                        <v-btn color="danger" class="white--text ml-5" small text @click="confirmDelete">Delete</v-btn>
                    </v-card-actions>
                </div>
                <div v-else>
                    <v-card-actions class="mr-4 mt-n5">
                        <v-spacer></v-spacer>
                        <v-btn color="accent" :disabled="groupName === '' || selectedMeters.length === 0" small class="ml-5" @click="save">Save</v-btn>
                    </v-card-actions>
                </div>
                <v-dialog v-model="openDelete" persistent width="370" class="align-center">
                    <template>
                        <v-card height="auto">
                        <v-toolbar :elevation="0" color="primary" dark>
                            <v-toolbar-title>Delete group</v-toolbar-title>
                        </v-toolbar>
                            <v-form ref="form" class="text-center my-3">
                                Do you want to delete "{{group_id}}" group?
                            </v-form>
                            <div align="right" class="align-content-end mx-4">
                                <v-btn color="danger" 
                                    small
                                    class="white--text mx-2 mb-3" 
                                    @click="deleteOfc"
                                    >Delete
                                </v-btn>
                                <v-btn color="danger" 
                                    small 
                                    text
                                    class="mb-3"
                                    @click="close"
                                    >Cancel
                                </v-btn>
                            </div>
                        </v-card>
                    </template>
                </v-dialog>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="success" :timeout="3000">
            Group deleted successfully
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="error"
                    text
                    v-bind="attrs"
                    @click="success = false"
                >
                    Close
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import formDelete from './formDelete'
import formConfirmation from './formConfirmation'
export default {
    name: 'formGroups',
    props: ['open', 'group_id', 'group_meters', 'prev'],
    computed:{ ...mapState({ 
        meters: state => state.meters.meters,
        groupMeters: state => state.meters.groupMeters
    })},
    components: { formDelete, formConfirmation },
    data() {
        return {
            selectedMeters: [],
            groupName: '',
            openDelete: false,
            success: false,
            groupData: {name: '', meters: []}
        }
    },
    methods: {
        ...mapActions({ createNewGroup: 'meters/createNewGroup', editGroup: 'meters/editGroup', deleteFromGroup: 'meters/deleteFromGroup', deleteGroup: 'meters/deleteGroup' }),
        close(){
            this.openDelete = false
            this.reset()
            this.$emit('close')
        },
        reset(){
            this.groupName = ''
            this.selectedMeters = []
        },
        async save(){
            if (this.group_id === '') {
                await this.createNewGroup({ name: this.groupName, meters: this.selectedMeters })
            } else {
                await this.deleteFromGroup({ name: this.group_id, newName: this.groupData.name, meters: this.group_meters.meters, newMeters: this.groupData.meters })
                await this.editGroup({ name: this.group_id, newName: this.groupData.name, meters: this.group_meters.meters, newMeters: this.groupData.meters })
            }
            this.close()
        },
        show(item){
            return item
        },
        async remove(item) {
            let index = this.groupData.meters.indexOf(item)
            if (index >= 0) this.groupData.meters.splice(index, 1)
            else {
                index = this.selectedMeters.indexOf(item)
                this.selectedMeters.splice(index, 1)
                return
            }
            await this.deleteFromGroup({meters: [item]})
        },
        async confirmDelete(){
            this.openDelete = true
        },
        async deleteOfc(){
            await this.deleteGroup({ name: this.group_id, meters: this.group_meters.meters })
            this.sleep(1000).then(() => { this.close(); })
            this.success = true
        },
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
    },
    watch:{
        group_id(){
            if(this.group_id){
                this.groupData.name = this.group_id
                this.groupData.meters = this.group_meters.meters
            }
        },
    },
}
</script>

<style scoped>
</style>